import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 48, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 1, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => {
    const ref = useRef(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setShow(true);
                    io.disconnect();
                }
            },
            { rootMargin: "-40px" },
        );
        io.observe(el);
        return () => io.disconnect();
    }, []);

    return (
        <span ref={ref} className={`block overflow-hidden ${className}`}>
            <span
                className="mask-line-inner block will-change-transform"
                style={{
                    transitionDelay: `${delay}s`,
                    transform: show ? "translateY(0%)" : "translateY(112%)",
                }}
            >
                {children}
            </span>
        </span>
    );
};

export const HeroLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.2, delay, ease: EASE }}
            className="block will-change-transform"
        >
            {children}
        </motion.span>
    </span>
);
